<template>
    <div v-if="showContextHelp">
        <v-navigation-drawer
            v-model="showContextHelp"
            absolute
            right
            temporary
            class="navigation-drawer"
        >
            <div>
                <v-icon color="434a4f" class="close" @click="showContextHelp = !showContextHelp">$vuetify.icons.times</v-icon>
                <FAQContent/>
            </div>
        </v-navigation-drawer>
    </div>
</template>

<script>
    import FAQContent from "@/views/help/FAQContent.vue";

    export default {
        name: "FAQDrawer",
        components: {FAQContent},

        props: {
            value: {
                type: Boolean,
                default: false,
            }
        },

        computed: {

            showContextHelp: {
                get() {
                    return this.value
                },

                set(value) {
                    this.$emit("input", value)
                },
            },
        },
    }
</script>

<style lang="scss" scoped>
    .navigation-drawer {
        width: 560px !important;
        position: fixed;
        top: 0;
        right: 0;
        overflow-y: scroll;
    }

    .v-menu__content {
        width: to_rem(770px);
        max-width: to_rem(770px);
        margin: auto;
        overflow-y: scroll;
        max-height: 90vh;
    }

    .close {
        stroke: $grey-darken-2 !important;
        position: absolute !important;
        z-index: 20 !important;
        top: 30px;
        right: 23px;
    }

    .v-tab {
        font-style: normal;
        font-weight: 350;
        font-size: to_rem(14px);
        line-height: to_rem(20px);
        text-align: center;
        color: $grey-darken-2;
        border-bottom: to_rem(2px) solid $grey-lighten-1;
        &.v-tab--active {
            font-weight: 600;
            color: $secondary-color;
        }
    }

    .v-expansion-panel {
        &:before {
            box-shadow: 0 1px 1px rgb(0 0 0 / 10%);
        }

        .v-expansion-panel-header {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(18px);
            line-height: to_rem(28px);

            color: $primary-color;
        }
    }

    .v-card__title {
        display: flex;
        justify-content: space-between;
        padding-left: to_rem(16px);
        padding-top: to_rem(24px);
        padding-right: to_rem(22px);
        h1 {
            font-style: normal;
            font-weight: 600;
            font-size: to_rem(22px);
            line-height: to_rem(28px);
            letter-spacing: -0.5px;
            color: $primary-color;
        }
    }
</style>
